module.exports = __webpack_public_path__ + "files/98555ed5d1c20b32d2986b18723f7618.png";